export default __webpack_public_path__ + "static/media/burgerMenu.33efd054.svg";